import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #111;
`;

export const BreadcrumbNav = styled.nav`
  ol {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const CrumbItem = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CrumbLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
  color: #6b7280;

  svg {
    stroke: currentColor;
  }
`;

export const CrumbText = styled.span`
  font-size: 0.875rem;
  color: #111827;
`;
